var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.72505 1.90478L7.57066 3.51884C7.53995 3.83987 7.35631 4.12638 7.07745 4.28835L6.76854 4.46777C6.43235 4.66303 6.01346 4.64574 5.6945 4.42344L4.971 3.91918C4.47817 3.57569 3.79586 3.74116 3.51513 4.27225L1.42047 8.23487C1.18141 8.68711 1.32219 9.24684 1.74675 9.53217L2.58679 10.0968C2.8632 10.2825 3.02899 10.5937 3.02899 10.9267V11.6065C3.02899 11.9788 2.82217 12.3202 2.49224 12.4927L1.90025 12.8021C1.40536 13.0608 1.21823 13.6747 1.48467 14.1655L3.61668 18.0926C3.85969 18.5403 4.40032 18.7337 4.87215 18.5419L6.22293 17.9927C6.49519 17.882 6.80236 17.8967 7.06282 18.0328L7.20452 18.1069C7.57043 18.2982 7.78116 18.6947 7.73499 19.105L7.64685 19.8882C7.58014 20.481 8.04401 21 8.64058 21H12.8986C13.4508 21 13.8986 20.5523 13.8986 20V19.0623C13.8986 18.6731 14.1243 18.3194 14.4772 18.1554L14.7301 18.0379C15.0264 17.9002 15.3712 17.9159 15.6537 18.08L16.9099 18.8096C17.4016 19.0952 18.0323 18.9138 18.2971 18.4105L20.595 14.0426C20.8272 13.6012 20.6986 13.0561 20.2936 12.765L19.0975 11.9053C18.8361 11.7174 18.6812 11.4152 18.6812 11.0933V10.966C18.6812 10.6116 18.8687 10.2836 19.1742 10.104L20.16 9.52427C20.6274 9.24942 20.7906 8.65216 20.5279 8.17782L18.3061 4.16562C18.0346 3.67547 17.4135 3.50395 16.929 3.78535L15.7051 4.49617C15.3946 4.67654 15.0112 4.67654 14.7007 4.49617L14.3963 4.31941C14.0882 4.14044 13.8986 3.81102 13.8986 3.45468V2C13.8986 1.44772 13.4508 1 12.8986 1H8.72051C8.20511 1 7.77412 1.39172 7.72505 1.90478Z",
    stroke: "#374673",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0366 10.5131C15.3385 12.8813 13.7134 15.0057 11.4524 15.294C9.19146 15.5822 7.0853 13.9335 6.78339 11.5653C6.48147 9.1971 8.1066 7.07266 10.3676 6.78442C12.6285 6.49617 14.7347 8.14492 15.0366 10.5131Z",
    stroke: "#374673",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56744 13.6968L7.56797 13.2366C7.56802 13.1933 7.57447 13.15 7.59141 13.1101C7.73153 12.7801 8.1929 12.1873 9.12763 12.0222C9.14914 12.0184 9.17011 12.0167 9.19195 12.0167C9.49643 12.0171 11.3226 12.0192 12.236 12.0202C12.731 11.9857 13.8263 12.5897 14.2489 14.0198",
    stroke: "#374673",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.8679,
    cy: 9.99688,
    r: 1.25,
    transform: "rotate(-7.2653 10.8679 9.99688)",
    stroke: "#374673",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingClose);
export default __webpack_public_path__ + "static/media/setting-close.f02af3f1c07d612abddfe4a4acd4a447.svg";
export { ForwardRef as ReactComponent };